import 'bootstrap/js/dist/modal';
import util from 'bootstrap/js/dist/util';
import $ from 'jquery';
import { ERROR_MODAL } from 'Constants/modalTypes';
import mediator from 'Utilities/mediator';
import { isObjectEmpty } from 'Utilities/newyu';
import { store } from 'Utilities/store';
import { DRAW_MODAL, REMOVE_MODAL } from 'src/reducers/modal/types';
const _element = '#modal-root';
const _renderFixInterval = 0;
let hiding = false;
let showing = false;
let wantToHide = false;
let wantToShow = false;
let wantToShowOptions = {};
const displayErrorModal = options => {
  const {
    nav: {
      maintenance
    }
  } = store.getState();

  // we really mean it
  if (maintenance === true) {
    return;
  }
  if (options.error && typeof options.error != 'object') {
    options.error = {};
  }
  mediator.request('modal:hide').then(() => {
    store.dispatch({
      type: DRAW_MODAL,
      modal: ERROR_MODAL,
      props: {
        ...options
      }
    });
  });
};
const hideModal = request => {
  request.response = new Promise(resolve => {
    // Since the previous modal is showing, we want to remember to hide once the previous is done showing
    if (showing) {
      wantToHide = true;
      resolve();
      return;
    }

    // Modal is already hidden, so we dispatch a remove and resolve immediately
    if (!$(_element).hasClass('show')) {
      store.dispatch({
        type: REMOVE_MODAL
      });
      resolve();
      return;
    }

    // @ts-ignore
    $(_element).modal('hide');
    const transitionDuration = util.getTransitionDurationFromElement(_element);

    // Resolve once the modal is done transitioning
    $(_element).one(util.TRANSITION_END, function () {
      resolve();
    }).emulateTransitionEnd(transitionDuration);
  });
};

/**
 * In order to make sure our modal options are updated when they change, since we maintain a single
 * modal, we must modify it's data object.
 * I suppose the intended use of modal that that a new one is created for each use, but this works
 * well
 *
 * NOTE: this could change at the drop of a hat, for example this works differently than it did
 * in BS3
 *
 * Got the answer from: https://stackoverflow.com/a/49247309
 * @param {*} options bootstrap modal options object
 */
const _modalWithOptions = options => {
  if (isObjectEmpty($(_element).data('bs.modal'))) {
    // @ts-ignore
    $(_element).modal(options);
  } else {
    $(_element).data('bs.modal')._config = options;
    // @ts-ignore
    $(_element).modal();
  }
};
const showModal = request => {
  request.response = new Promise(resolve => {
    const {
      backdrop = true,
      focus = true,
      keyboard = true,
      show = true
    } = request;

    // Since the previous modal is hiding, we want to remember to show this modal once the previous is done hiding
    if (hiding) {
      wantToShow = true;
      wantToShowOptions = {
        backdrop,
        focus,
        keyboard,
        show
      };
      resolve();
      return;
    }

    // Modal is already visible, so we update the modal options and resolove imediately
    if ($(_element).hasClass('show')) {
      _modalWithOptions({
        backdrop,
        focus,
        keyboard,
        show
      });
      resolve();
      return;
    }
    _modalWithOptions({
      backdrop,
      focus,
      keyboard,
      show
    });
    const transitionDuration = util.getTransitionDurationFromElement(_element);

    // Resolve once the modal is done transitioning
    $(_element).one(util.TRANSITION_END, function () {
      resolve();
    }).emulateTransitionEnd(transitionDuration);
  });
};
$(_element).on('hide.bs.modal', function () {
  hiding = true;
  window.clearInterval(_renderFixInterval);
});
$(_element).on('hidden.bs.modal', function () {
  hiding = false;
  if (wantToShow) {
    wantToShow = false;
    showModal(wantToShowOptions);
  } else {
    store.dispatch({
      type: REMOVE_MODAL
    });
  }
});
$(_element).on('show.bs.modal', function () {
  showing = true;
});
$(_element).on('shown.bs.modal', function () {
  showing = false;
  if (wantToHide) {
    wantToHide = false;
    hideModal({});
  }
});
mediator.subscribe('error:display', displayErrorModal);
mediator.subscribe('modal:hide', hideModal);
mediator.subscribe('modal:show', showModal);